(() => {
  const sectionSelector = '.home-v4-category-products';

  const updateVariantState = (content) => {
    const select = content.querySelector('[data-quick-view-variant-select]');
    const price = content.querySelector('[data-quick-view-price]');
    const addButton = content.querySelector('[data-quick-view-add]');

    if (!select || !price || !addButton) return;

    const update = () => {
      const option = select.options[select.selectedIndex];
      const isAvailable = option.dataset.quickViewVariantAvailable === 'true';

      price.textContent = option.dataset.quickViewVariantPrice || price.textContent;
      addButton.disabled = !isAvailable;
      addButton.textContent = isAvailable ? 'Add to Cart' : 'Sold Out';
    };

    select.addEventListener('change', update);
    update();
  };

  const initializeGallery = (content) => {
    const mainImage = content.querySelector('#QuickViewMainImage');
    const thumbnails = Array.from(content.querySelectorAll('.quick-view-thumbnail'));
    const prevButton = content.querySelector('[data-quick-view-prev]');
    const nextButton = content.querySelector('[data-quick-view-next]');
    const mainImageContainer = content.querySelector('.quick-view-main-image');

    if (!mainImage) return;

    let currentIndex = thumbnails.findIndex((item) => item.classList.contains('is-active'));
    if (currentIndex === -1) currentIndex = 0;

    const setActiveIndex = (newIndex) => {
      if (!thumbnails.length) return;
      currentIndex = (newIndex + thumbnails.length) % thumbnails.length;
      const activeThumbnail = thumbnails[currentIndex];
      const image = activeThumbnail?.dataset.image;
      const thumbnailImage = activeThumbnail?.querySelector('img');

      if (!image) return;

      mainImage.src = image;
      mainImage.removeAttribute('srcset');
      mainImage.removeAttribute('sizes');

      if (thumbnailImage?.alt) {
        mainImage.alt = thumbnailImage.alt;
      }

      thumbnails.forEach((item, idx) => {
        const isActive = idx === currentIndex;
        item.classList.toggle('is-active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
        } else {
          item.removeAttribute('aria-current');
        }
      });

      if (typeof activeThumbnail.scrollIntoView === 'function') {
        activeThumbnail.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    };

    thumbnails.forEach((thumbnail, idx) => {
      thumbnail.addEventListener('click', () => {
        setActiveIndex(idx);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', (e) => {
        e.stopPropagation();
        setActiveIndex(currentIndex - 1);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', (e) => {
        e.stopPropagation();
        setActiveIndex(currentIndex + 1);
      });
    }

    if (mainImageContainer && thumbnails.length > 1) {
      let touchStartX = 0;
      let touchStartY = 0;

      mainImageContainer.addEventListener('touchstart', (e) => {
        if (!e.touches || e.touches.length === 0) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
      }, { passive: true });

      mainImageContainer.addEventListener('touchend', (e) => {
        if (!e.changedTouches || e.changedTouches.length === 0) return;
        const diffX = e.changedTouches[0].clientX - touchStartX;
        const diffY = e.changedTouches[0].clientY - touchStartY;

        if (Math.abs(diffX) > 35 && Math.abs(diffX) > Math.abs(diffY)) {
          if (diffX < 0) {
            setActiveIndex(currentIndex + 1);
          } else {
            setActiveIndex(currentIndex - 1);
          }
        }
      }, { passive: true });
    }

    content.addEventListener('keydown', (e) => {
      if (thumbnails.length <= 1) return;
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'INPUT') return;

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        setActiveIndex(currentIndex - 1);
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        setActiveIndex(currentIndex + 1);
      }
    });
  };

  const initializeForm = (content, closeModal) => {
    const form = content.querySelector('.quick-view-modal__form');
    if (!form) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const select = form.querySelector('[data-quick-view-variant-select]');
      const variantId = select?.value;
      if (!variantId) return;

      const addButton = form.querySelector('[data-quick-view-add]');
      const originalText = addButton?.textContent || 'Add to Cart';

      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = 'Adding...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ],
            sections: 'cart-drawer-section'
          })
        });

        const data = await response.json();

        if (data.status && data.status >= 400) {
          alert(data.description || data.message || 'Could not add item to cart');
          if (addButton) {
            addButton.disabled = false;
            addButton.textContent = originalText;
          }
          return;
        }

        if (data.sections && data.sections['cart-drawer-section']) {
          try {
            const { morphSection } = await import('@theme/section-renderer');
            await morphSection('cart-drawer-section', data.sections['cart-drawer-section'], {
              mode: 'hydration',
              injectStylesheet: true
            });
          } catch (morphError) {
            console.warn('Could not morph cart-drawer-section:', morphError);
          }
        }

        try {
          const cartRes = await fetch('/cart.js');
          const cart = await cartRes.json();
          const cartIcon = document.querySelector('cart-icon');
          if (cartIcon && typeof cartIcon.renderCartBubble === 'function') {
            cartIcon.renderCartBubble(cart.item_count);
          }
        } catch (bubbleError) {
          console.warn('Could not update cart bubble:', bubbleError);
        }

        closeModal();

        const cartDrawer = document.getElementById('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
      } catch (error) {
        console.error('Quick view add to cart error:', error);
        if (addButton) {
          addButton.disabled = false;
          addButton.textContent = originalText;
        }
      }
    });
  };

  const initializeSection = (section) => {
    if (!section || section.dataset.quickViewInitialized === 'true') return;

    const modal = section.querySelector('[data-quick-view-modal]');
    const content = modal?.querySelector('[data-quick-view-content]');
    const closeButton = modal?.querySelector('[data-quick-view-close]');

    if (!modal || !content || !closeButton || typeof modal.showModal !== 'function') return;

    let lastTrigger = null;

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    section.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-quick-view-trigger]');
      if (!trigger || !section.contains(trigger)) return;

      const template = document.getElementById(trigger.dataset.quickViewTemplate);
      if (!(template instanceof HTMLTemplateElement) || !section.contains(template)) return;

      event.preventDefault();
      lastTrigger = trigger;
      content.replaceChildren(template.content.cloneNode(true));
      initializeGallery(content);
      updateVariantState(content);
      initializeForm(content, closeModal);
      document.documentElement.setAttribute('scroll-lock', '');
      modal.showModal();
      closeButton.focus();
    });

    closeButton.addEventListener('click', closeModal);

    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });

    modal.addEventListener('close', () => {
      document.documentElement.removeAttribute('scroll-lock');
      content.replaceChildren();
      lastTrigger?.focus();
      lastTrigger = null;
    });

    section.dataset.quickViewInitialized = 'true';
  };

  const initialize = (scope = document) => {
    if (scope.matches?.(sectionSelector)) initializeSection(scope);
    scope.querySelectorAll?.(sectionSelector).forEach(initializeSection);
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
